import React from 'react';
import FolderContentList from './FolderContentList';
import FolderContentListContainer, {
  OwnProps,
} from './FolderContentList.container';

export default FolderContentListContainer(
  FolderContentList
) as React.ComponentType<OwnProps>;
